import React from 'react';
import './Testimonial.css';

const Testimonial = () => {
    return (
      <div className='mt-5'>
        <body>
          <div class="wrapper">
            <div class="box">
              <i class="fas fa-quote-left quote"></i>
              <p>
                Lorem aliasry ipsum dolor sits ametans, consectetur adipisicing
                elitits. Expedita reiciendis itaque placeat thuratu, quasi yiuos
                repellendus repudiandae deleniti ideas fuga molestiae, alias.
              </p>
              <div class="content">
                <div class="info">
                  <div class="name">Alex Smith</div>
                  <div class="job">Designer | Developer</div>
                  <div class="stars">
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="far fa-star"></i>
                    <i class="far fa-star"></i>
                    <i class="far fa-star"></i>
                  </div>
                </div>
                <div class="image">
                  <img
                    src="https://www.richterstudios.com/wp-content/uploads/2018/12/Testimonial-Rebecca.jpg"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div class="box">
              <i class="fas fa-quote-left quote"></i>
              <p>
                Lorem aliasry ipsum dolor sits ametans, consectetur adipisicing
                elitits. Expedita reiciendis itaque placeat thuratu, quasi yiuos
                repellendus repudiandae deleniti ideas fuga molestiae, alias.
              </p>
              <div class="content">
                <div class="info">
                  <div class="name">Steven Chris</div>
                  <div class="job">YouTuber | Blogger</div>
                  <div class="stars">
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="far fa-star"></i>
                    <i class="far fa-star"></i>
                  </div>
                </div>
                <div class="image">
                  <img
                    src="https://www.cloudways.com/wp-content/uploads/2020/01/testimonial-edward.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div class="box">
              <i class="fas fa-quote-left  quote"></i>
              <p>
                Lorem aliasry ipsum dolor sits ametans, consectetur adipisicing
                elitits. Expedita reiciendis itaque placeat thuratu, quasi yiuos
                repellendus repudiandae deleniti ideas fuga molestiae, alias.
              </p>
              <div class="content">
                <div class="info">
                  <div class="name">Kristina Bellis</div>
                  <div class="job">Freelancer | Advertiser</div>
                  <div class="stars">
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="far fa-star"></i>
                  </div>
                </div>
                <div class="image">
                  <img
                    src="https://www.airphysio.com/wp-content/uploads/2020/02/testimonial.jpg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </body>
      </div>
    );
};

export default Testimonial;